import { render } from "./clients-details.vue?vue&type=template&id=78178881"
import script from "./clients-details.vue?vue&type=script&lang=js"
export * from "./clients-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__